// filepath: src/component/page/poll/redux/pollReducer.js
import {
    FETCH_POLLS_REQUEST,
    FETCH_POLLS_SUCCESS,
    FETCH_POLLS_FAILURE,
    CREATE_POLL_REQUEST,
    CREATE_POLL_SUCCESS,
    CREATE_POLL_FAILURE,
    DELETE_POLL_REQUEST,
    DELETE_POLL_SUCCESS,
    DELETE_POLL_FAILURE,
    VOTE_POLL_REQUEST,
    VOTE_POLL_SUCCESS,
    VOTE_POLL_FAILURE,
    UPDATE_POLL_REQUEST,
    UPDATE_POLL_SUCCESS,
    UPDATE_POLL_FAILURE,
    CLOSE_POLL_REQUEST,
    CLOSE_POLL_SUCCESS,
    CLOSE_POLL_FAILURE,
    FETCH_POLL_DETAILS_REQUEST,
    FETCH_POLL_DETAILS_SUCCESS,
    FETCH_POLL_DETAILS_FAILURE,
    FETCH_USER_VOTES_REQUEST,
    FETCH_USER_VOTES_SUCCESS,
    FETCH_USER_VOTES_FAILURE
} from './pollActions';

const initialState = {
    list: [],
    loading: false,
    error: null,
    currentPoll: null,
    currentPollLoading: false,
    userVotes: {},
    pagination: {
        page: 1,
        limit: 20,
        total: 0
    }
};

export const pollReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POLLS_REQUEST:
        case CREATE_POLL_REQUEST:
        case DELETE_POLL_REQUEST:
        case VOTE_POLL_REQUEST:
        case UPDATE_POLL_REQUEST:
        case CLOSE_POLL_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_POLL_DETAILS_REQUEST:
            return { ...state, currentPollLoading: true, error: null };

        case FETCH_USER_VOTES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_POLLS_SUCCESS:
            // Handle potential pagination information if the API returns it
            let pagination = state.pagination;
            if (action.payload.pagination) {
                pagination = action.payload.pagination;
            }
            return {
                ...state,
                loading: false,
                list: action.payload.polls || action.payload,
                pagination,
                error: null
            };

        case FETCH_POLLS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error || 'Failed to load polls',
                list: action.fallback || state.list
            };

        case CREATE_POLL_SUCCESS:
            return { ...state, loading: false, list: [...state.list, action.payload] };

        case CREATE_POLL_FAILURE:
            return { ...state, loading: false, error: action.error || 'Failed to create poll' };

        case DELETE_POLL_SUCCESS:
            return { ...state, loading: false, list: state.list.filter(p => p.id !== action.payload) };

        case DELETE_POLL_FAILURE:
            return { ...state, loading: false, error: action.error || 'Failed to delete poll' };

        case VOTE_POLL_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map(poll => {
                    if (poll.id !== action.payload.pollId) return poll;
                    return {
                        ...poll,
                        options: poll.options.map(option => {
                            if (option.id !== action.payload.optionId) return option;
                            return {
                                ...option,
                                votes: (option.votes || 0) + 1
                            };
                        })
                    };
                }),
                userVotes: {
                    ...state.userVotes,
                    [action.payload.pollId]: action.payload.optionId
                }
            };

        case VOTE_POLL_FAILURE:
            return { ...state, loading: false, error: action.error || 'Failed to vote on poll' };

        case UPDATE_POLL_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map(poll =>
                    poll.id === action.payload.id ? action.payload : poll
                ),
                currentPoll: state.currentPoll?.id === action.payload.id
                    ? action.payload
                    : state.currentPoll
            };

        case UPDATE_POLL_FAILURE:
            return { ...state, loading: false, error: action.error || 'Failed to update poll' };

        case CLOSE_POLL_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map(poll =>
                    poll.id === action.payload.id
                        ? { ...action.payload, isClosed: true }
                        : poll
                ),
                currentPoll: state.currentPoll?.id === action.payload.id
                    ? { ...action.payload, isClosed: true }
                    : state.currentPoll
            };

        case CLOSE_POLL_FAILURE:
            return { ...state, loading: false, error: action.error || 'Failed to close poll' };

        case FETCH_POLL_DETAILS_SUCCESS:
            return {
                ...state,
                currentPollLoading: false,
                currentPoll: action.payload,
                error: null
            };

        case FETCH_POLL_DETAILS_FAILURE:
            return {
                ...state,
                currentPollLoading: false,
                error: action.error || 'Failed to fetch poll details'
            };

        case FETCH_USER_VOTES_SUCCESS:
            return {
                ...state,
                loading: false,
                userVotes: action.payload,
                error: null
            };

        case FETCH_USER_VOTES_FAILURE:
            return {
                ...state,
                loading: false,
                userVotes: action.fallback || {},
                error: action.error || 'Failed to fetch user votes'
            };

        default:
            return state;
    }
};

export default pollReducer;
